import { defineComponent as _defineComponent } from 'vue'
import { normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "input-group" }
const _hoisted_2 = ["id", "name", "autocomplete", "required", "aria-required", "disabled", "value"]
const _hoisted_3 = ["type", "id", "name", "autocomplete", "required", "aria-required", "disabled", "value"]
const _hoisted_4 = ["for"]
const _hoisted_5 = {
  key: 0,
  class: "required"
}

import { computed, ref } from "vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'CommonInput',
  props: {
    name: {},
    type: {},
    value: {},
    label: {},
    autocomplete: {},
    invalid: {},
    required: { type: Boolean },
    disabled: { type: Boolean }
  },
  emits: ["update:value"],
  setup(__props: any, { emit: __emit }) {

const props = __props;
const emit = __emit;

const focussed = ref(false);
const inputType = computed(() => props.type || "text");

const handleBlur = () => (focussed.value = true);
const updateValue = (event: Event) => {
    const target = event.target as HTMLInputElement | HTMLTextAreaElement | null;
    if (!target) {
        return;
    }
    emit("update:value", target.value);
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (inputType.value == 'area')
      ? (_openBlock(), _createElementBlock("textarea", {
          key: 0,
          class: _normalizeClass([{ focussed: focussed.value }, "peer"]),
          id: __props.name,
          name: __props.name,
          autocomplete: __props.autocomplete,
          required: __props.required ? true : false,
          "aria-required": __props.required || false,
          placeholder: " ",
          onBlur: handleBlur,
          onInput: updateValue,
          disabled: __props.disabled,
          value: __props.value
        }, null, 42, _hoisted_2))
      : (_openBlock(), _createElementBlock("input", {
          key: 1,
          type: inputType.value,
          class: _normalizeClass([{ focussed: focussed.value }, "peer"]),
          id: __props.name,
          name: __props.name,
          autocomplete: __props.autocomplete,
          required: __props.required ? true : false,
          "aria-required": __props.required || false,
          placeholder: " ",
          onBlur: handleBlur,
          onInput: updateValue,
          disabled: __props.disabled,
          value: __props.value
        }, null, 42, _hoisted_3)),
    (__props.label)
      ? (_openBlock(), _createElementBlock("label", {
          key: 2,
          for: __props.name,
          class: "peer-focus:-translate-y-3 peer-focus:translate-x-1 peer-focus:scale-75 peer-focus:font-medium peer-focus:start-0 peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-1 peer-placeholder-shown:translate-x-0 rtl:peer-focus:left-auto rtl:peer-focus:translate-x-1/4"
        }, [
          _createTextVNode(_toDisplayString(__props.label), 1),
          (__props.required)
            ? (_openBlock(), _createElementBlock("sup", _hoisted_5, "*"))
            : _createCommentVNode("", true)
        ], 8, _hoisted_4))
      : _createCommentVNode("", true),
    (__props.invalid)
      ? (_openBlock(), _createElementBlock("p", {
          key: 3,
          class: _normalizeClass([{ 'never-focussed': !focussed.value, disabled: __props.disabled }, "invalid peer-invalid:h-4 peer-invalid:opacity-100"])
        }, _toDisplayString(__props.invalid), 3))
      : _createCommentVNode("", true)
  ]))
}
}

})